<template>
  <div>
    <div class="common">
      <!-- 搜索 -->
      <div class="top clearfix">
        <div class="fl">
          搜索：<el-input
            type="text"
            class="score-input"
            v-model="keyword"
            @change="selectLsit(1)"
            size="small"
            style="width: 150px"
            placeholder="请输入关键字"
            clearable
          ></el-input>
          学年：
          <el-date-picker
            class="search-year"
            style="width: 100px"
            v-model="searchYear"
            value-format="yyyy"
            size="small"
            type="year"
            @change="selectLsit(1)"
          >
          </el-date-picker>
          学期：
          <el-select
            clearable
            v-model="searchTerm"
            size="small"
            @change="selectLsit(1)"
          >
            <template v-for="i of dic.schoolTerm">
              <el-option
                :key="i.id"
                :label="i.dicName"
                :value="i.dicCode"
              ></el-option>
            </template>
          </el-select>
          学科：
          <el-select
            v-model="disciplineCode"
            placeholder="全部学科"
            @change="selectLsit(1)"
            clearable
          >
            <el-option
              v-for="i in subjectOptions"
              :key="i.id"
              :label="i.disciplineName"
              :value="i.disciplineCode"
            ></el-option>
          </el-select>
        </div>
        <div class="fr">
          <el-button
            size="small"
            icon="iconfont icon-daochu"
            @click="importTeacher"
            v-if="isAdmin"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.9)"
        v-loading="isTableLoading"
        row-key="id"
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#EFEFEF' }"
        @sort-change="sortChange"
      >
        <el-table-column
          prop="teacherName"
          label="姓名"
          width="100"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="disciplineName" label="学科"> </el-table-column>
        <el-table-column
          v-if="scoreMenuCodeList.includes('stu-prize')"
          prop="stuPrizeCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'stu-prize').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('single-prize_ssdt')"
          prop="singlePrizeCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'single-prize_ssdt')
              .menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('single-prize')"
          prop="singlePrizeCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'single-prize').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('resource')"
          prop="resourceCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'resource').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('cultivate_ssdt')"
          prop="cultivateCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'cultivate_ssdt').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('cultivate')"
          prop="cultivateCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'cultivate').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('promotion_ssdt')"
          prop="promotionCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'promotion_ssdt').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('promotion')"
          prop="promotionCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'promotion').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('paper')"
          prop="paperCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'paper').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('curriculum_ssdt')"
          prop="curriculumCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'curriculum_ssdt').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('curriculum')"
          prop="curriculumCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'curriculum').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('publicTeaching')"
          prop="publicTeachingCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'publicTeaching').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('publicTeaching_ssdt')"
          prop="publicTeachingCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'publicTeaching_ssdt')
              .menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('case-lesson')"
          prop="caseLessonCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'case-lesson').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('mtyj_zysj')"
          prop="mtyjzysjCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'mtyj_zysj').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('competition')"
          prop="competitionCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'competition').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('ztjz')"
          prop="ztjzCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'ztjz').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('microVedio')"
          prop="microVedioCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'microVedio').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('contest')"
          prop="moralCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'contest').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('guidance')"
          prop="guidanceCount"
          :label="scoreMenuList.find((u) => u.menuCode == 'guidance').menuName"
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('school-award')"
          prop="schoolAwardCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'school-award').menuName
          "
          sortable="custom"
        />
        <el-table-column
          v-if="scoreMenuCodeList.includes('major-project')"
          prop="majorProjectCount"
          :label="
            scoreMenuList.find((u) => u.menuCode == 'major-project').menuName
          "
          sortable="custom"
        />
      </el-table>
      <!-- 分页 -->
      <pagination
        :pageObj="pageObj"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import { exportExecl } from "@/utils/index";
import { mapState } from "vuex";
import { mixin } from "@/mixin/mixin";
export default {
  mixins: [mixin],
  components: {
    Pagination,
  },
  computed: {
    ...mapState([
      "scoreMenuList",
      "isAdmin",
      "userInfo",
      "dic",
      "teacherLoading",
    ]),
    scoreMenuCodeList() {
      return this.scoreMenuList.map((item) => item.menuCode);
    },
  },
  data() {
    return {
      isTableLoading: false,
      searchYear: "",
      searchTerm: "",
      keyword: "",
      disciplineCode: "",
      tableData: [],
      subjectOptions: [],
      pageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25, 30],
      },
      orderBy: "",
      orderType: "",
    };
  },
  created() {
    this.getDicSubject();
    this.selectLsit(1); //首页list
  },
  methods: {
    //首页 查询首页list
    selectLsit(curPage, pageSize, orderBy, orderType) {
      this.orderBy = orderBy;
      this.orderType = orderType;
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
        isAdmin: this.isAdmin / 1,
        operatorId: this.userInfo.userId,
        orderBy: orderBy,
        orderType: orderType,
        keyword: this.keyword || "",
        disciplineCode: this.disciplineCode || "",
      };
      this.isTableLoading = true;
      this.$axios
        .post("/rpt/getTeacherModelCountList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
            console.log(res.data.records);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.isTableLoading = false;
        })
        .catch((err) => {
          this.isTableLoading = false;
          console.log("教师error", err);
        });
    },
    //学科
    getDicSubject() {
      const paramsDicSubject = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
      };
      this.$axios.post("/user/listDiscipline", paramsDicSubject).then((res) => {
        if (res.data.records && res.data.records.length > 0) {
          this.subjectOptions = res.data.records;
        }
      });
    },
    //导出
    importTeacher() {
      this.isTableLoading = true;
      let exportData = {
        schoolCode: this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
        isAdmin: this.isAdmin / 1,
        operatorId: this.userInfo.userId,
        orderBy: this.orderBy,
        orderType: this.orderType,
        keyword: this.keyword || "",
        disciplineCode: this.disciplineCode || "",
      };
      this.$axios
        .post("/rpt/exportTeacherModelCount", this.$qs.stringify(exportData), {
          responseType: "blob",
        })
        .then((res) => {
          this.isTableLoading = false;
          let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          const url = URL.createObjectURL(res.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.click();
          URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.isTableLoading = false;
        });
    },

    //分页
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.selectLsit(1, pageSize);
    },
    handleCurrentChange(curPage) {
      this.selectLsit(curPage);
    },
    sortChange({ column, prop, order }) {
      console.log(column, prop, order);
      let orderType = "";
      switch (order) {
        case "ascending":
          orderType = 1;
          break;
        case "descending":
          orderType = 0;
          break;
        default:
          orderType = null;
          break;
      }

      this.selectLsit(1, this.pageObj.size, prop, orderType); //首页list
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../styles/common.less";
.top {
  .fl {
    width: calc(100% - 100px) !important;
    max-width: 800px !important;
    .check-status {
      margin-left: 15px;
    }
  }
}
</style>
